/**
 * @typedef {String} module:DeviceService.ProductFeatures
 * @readonly
 * @description Types of invoices that services can have
 * @property {String} ACCESS_DVR "ACCESS_DVR"
 * @property {String} "Analyze.Video.MyQResiVideo" "Analyze.Video.MyQResiVideo"
 * @property {String} AUDIO_LW_DVR "AUDIO_LW_DVR"
 * @property {String} CAM_FD_CLOUD_FR "CAM_FD_CLOUD_FR"
 * @property {String} CarSense "CarSense"
 * @property {String} CATEGORIZE_FRAMES "CATEGORIZE_FRAMES"
 * @property {String} CATEGORIZE_OBJECTS "CATEGORIZE_OBJECTS"
 * @property {String} CATEGORIZE_SCENE "CATEGORIZE_SCENE"
 * @property {String} DELIVERY_DVR "DELIVERY_DVR"
 * @property {String} DOORBELL_SNAPS_DVR "DOORBELL_SNAPS_DVR"
 * @property {String} EVENT_ENCRYPTION "EVENT_ENCRYPTION"
 * @property {String} FAVORITES "FAVORITES"
 * @property {String} FDFR_CLOUD_FD "FDFR_CLOUD_FD"
 * @property {String} FDFR_CLOUD_FR "FDFR_CLOUD_FR"
 * @property {String} FDFR_FOR_ALL_VID "FDFR_FOR_ALL_VID"
 * @property {String} FDFR_FOR_LMO "FDFR_FOR_LMO"
 * @property {String} FDFR_CLOUD_FR_TYPE "FDFR_CLOUD_FR_TYPE"
 * @property {String} FDFR_OD "FDFR_OD"
 * @property {String} GARAGE_ANALYSIS "GARAGE_ANALYSIS"
 * @property {String} GARAGE_ANALYSIS_POC1 "GARAGE_ANALYSIS_POC1"
 * @property {String} GARAGE_ANALYSIS_POC3 "GARAGE_ANALYSIS_POC3"
 * @property {String} HideShortEvents "HideShortEvents"
 * @property {String} HIGHLIGHT_VIDEO "HIGHLIGHT_VIDEO"
 * @property {String} LMO_TRACK "LMO_TRACK"
 * @property {String} MOTION_LW_DVR "MOTION_LW_DVR"
 * @property {String} MOTION_WEBHOOK "MOTION_WEBHOOK"
 * @property {String} NOTIFY_EMAIL "NOTIFY_EMAIL"
 * @property {String} NOTIFY_SMARTPHONE "NOTIFY_SMARTPHONE"
 * @property {String} NOTIFY_SMS "NOTIFY_SMS"
 * @property {String} OBJECT_TRACK "OBJECT_TRACK"
 * @property {String} PEOPLE_DETECT "PEOPLE_DETECT"
 * @property {String} PEOPLE_TRACK "PEOPLE_TRACK" // obsolete
 * @property {String} ProxyMediaUploads "ProxyMediaUploads"
 * @property {String} PET_DETECT "PET_DETECT"
 * @property {String} PET_TRACK "PET_TRACK"
 * @property {String} SNAPSHOT_DVR "SNAPSHOT_DVR"
 * @property {String} TERADEEP_DETECT "TERADEEP_DETECT"
 * @property {String} TERADEEP_LMO_TRACK "TERADEEP_LMO_TRACK"
 * @property {String} THUMBNAIL_SIZE "THUMBNAIL_SIZE"
 * @property {String} TIMELAPSE_VID "TIMELAPSE_VID"
 * @property {String} TIMELAPSE_VID_ANALYZE "TIMELAPSE_VID_ANALYZE"
 * @property {String} TIMELAPSE_PIC "TIMELAPSE_PIC"
 * @property {String} TIMELAPSE_PIC_ANALYZE_HR "TIMELAPSE_PIC_ANALYZE_HR"
 * @property {String} TIMELAPSE_PIC_ANALYZE_LR "TIMELAPSE_PIC_ANALYZE_LR"
 * @property {String} UnanonymizedEventStats "UnanonymizedEventStats"
 * @property {String} USER_PIC_ANALYZE_HR "USER_PIC_ANALYZE_HR"
 * @property {String} USER_PIC_ANALYZE_LR "USER_PIC_ANALYZE_LR"
 * @property {String} USER_VID_ANALYZE "USER_VID_ANALYZE"
 * @property {String} VIDEO_DVR "VIDEO_DVR"
 * @property {String} YOLO_DETECT "YOLO_DETECT"
 * @property {String} YOLO_TRACK "YOLO_TRACK"
 */
const productFeatures = Object.freeze({
    ACCESS_DVR: 'ACCESS_DVR',
    'Analyze.Video.MyQResiVideo': 'Analyze.Video.MyQResiVideo',
    AUDIO_LW_DVR: 'AUDIO_LW_DVR',
    CAM_FD_CLOUD_FR: 'CAM_FD_CLOUD_FR',
    CarSense: 'CarSense',
    CATEGORIZE_FRAMES: 'CATEGORIZE_FRAMES',
    CATEGORIZE_OBJECTS: 'CATEGORIZE_OBJECTS',
    CATEGORIZE_SCENE: 'CATEGORIZE_SCENE',
    DELIVERY_DVR: 'DELIVERY_DVR',
    DOORBELL_SNAPS_DVR: 'DOORBELL_SNAPS_DVR',
    EVENT_ENCRYPTION: 'EVENT_ENCRYPTION',
    FAVORITES: 'FAVORITES',
    FDFR_CLOUD_FD: 'FDFR_CLOUD_FD',
    FDFR_CLOUD_FR: 'FDFR_CLOUD_FR',
    FDFR_CLOUD_FR_TYPE: 'FDFR_CLOUD_FR_TYPE',
    FDFR_FOR_ALL_VID: 'FDFR_FOR_ALL_VID',
    FDFR_FOR_LMO: 'FDFR_FOR_LMO',
    FDFR_OD: 'FDFR_OD',
    GARAGE_ANALYSIS: 'GARAGE_ANALYSIS',
    GARAGE_ANALYSIS_POC1: 'GARAGE_ANALYSIS_POC1',
    GARAGE_ANALYSIS_POC3: 'GARAGE_ANALYSIS_POC3',
    HideShortEvents: 'HideShortEvents',
    HIGHLIGHT_VIDEO: 'HIGHLIGHT_VIDEO',
    LMO_TRACK: 'LMO_TRACK',
    MOTION_LW_DVR: 'MOTION_LW_DVR',
    MOTION_WEBHOOK: 'MOTION_WEBHOOK',
    NOTIFY_EMAIL: 'NOTIFY_EMAIL',
    NOTIFY_SMARTPHONE: 'NOTIFY_SMARTPHONE',
    NOTIFY_SMS: 'NOTIFY_SMS',
    OBJECT_TRACK: 'OBJECT_TRACK',
    PEOPLE_DETECT: 'PEOPLE_DETECT',
    PEOPLE_TRACK: 'PEOPLE_TRACK', // obsolete
    ProxyMediaUploads: 'ProxyMediaUploads',
    PET_DETECT: 'PET_DETECT',
    PET_TRACK: 'PET_TRACK',
    SNAPSHOT_DVR: 'SNAPSHOT_DVR',
    TERADEEP_DETECT: 'TERADEEP_DETECT',
    TERADEEP_LMO_TRACK: 'TERADEEP_LMO_TRACK',
    THUMBNAIL_SIZE: 'THUMBNAIL_SIZE',
    TIMELAPSE_VID: 'TIMELAPSE_VID',
    TIMELAPSE_VID_ANALYZE: 'TIMELAPSE_VID_ANALYZE',
    TIMELAPSE_PIC: 'TIMELAPSE_PIC',
    TIMELAPSE_PIC_ANALYZE_HR: 'TIMELAPSE_PIC_ANALYZE_HR',
    TIMELAPSE_PIC_ANALYZE_LR: 'TIMELAPSE_PIC_ANALYZE_LR',
    UnanonymizedEventStats: 'UnanonymizedEventStats',
    USER_PIC_ANALYZE_HR: 'USER_PIC_ANALYZE_HR',
    USER_PIC_ANALYZE_LR: 'USER_PIC_ANALYZE_LR',
    USER_VID_ANALYZE: 'USER_VID_ANALYZE',
    VIDEO_DVR: 'VIDEO_DVR',
    YOLO_DETECT: 'YOLO_DETECT',
    YOLO_TRACK: 'YOLO_TRACK'
});

export default productFeatures;
